import { Button, Grid, Section, Typography } from '@evocolabs/orkaui'

import { Box } from '@mui/material'
import Call40 from '@evocolabs/icons/lib/Call40'
import Download24 from '@evocolabs/icons/lib/Download24'
import EmailSimple40 from '@evocolabs/icons/lib/EmailSimple40'
import Footer from '@/src/components/Footer/Footer2'
import Header from '@/src/components/HeaderV2'
import { NextSeo } from 'next-seo'
import Note40 from '@evocolabs/icons/lib/Note40'
import { showLeaveQuestionsModal } from '@/src/components/LeaveQuestions/LeaveQuestionsSlices'
import styles from '@/src/components/scss/Support.module.scss'
import { useDispatch } from 'react-redux'
import { useState } from 'react'

const ContactCard = ({ id, icon, title, content, onClick }) => {
  return (
    <Box className={styles.contactCard} onClick={onClick} id={id}>
      {icon}
      <Typography variant="T2" textAlign="center">
        {title}
      </Typography>
      <Typography variant="body3" className={styles.contactCardContent}>
        {content}
      </Typography>
    </Box>
  )
}
const DownloadCard = ({ id, title, url }) => {
  return (
    <Grid id={id} xs={4} item>
      <a href={url} target="_blank" rel="noreferrer">
        <Box className={styles.downloadCard}>
          <Typography variant="T2">{title}</Typography>
          <Download24 />
        </Box>
      </a>
    </Grid>
  )
}

const GetStarted = () => {
  const [device, setDevice] = useState('Orka Two')
  return (
    <Section sx={{ py: '0 !important', mt: '64px', mb: 0 }}>
      <Typography variant="h2">Get Started</Typography>
      <div className={styles.downloadCardSelectionWrapper}>
        <div
          id="support_start_orkatwo"
          className={
            styles.downloadCardSelection +
            ' ' +
            (device === 'Orka Two' ? styles.selected : '')
          }
          onClick={() => {
            setDevice('Orka Two')
          }}
        >
          <Typography variant="Body2">Orka Two</Typography>
        </div>
        <div
          id="support_start_orkaone"
          className={
            styles.downloadCardSelection +
            ' ' +
            (device === 'Orka One' ? styles.selected : '')
          }
          onClick={() => {
            setDevice('Orka One')
          }}
        >
          <Typography variant="Body2">Orka One</Typography>
        </div>
      </div>
      {device === 'Orka One' ? (
        <div className={styles.downloadCardWrapper}>
          <DownloadCard
            id="support_start_guide_one"
            title="Quick Start Guide I"
            url="/QuickStartGuide.pdf"
          />
          <DownloadCard
            id="support_start_user_guide_one"
            title="User Guide I"
            url="/UserGuide.pdf"
          />
          <DownloadCard
            id="support_start_inapp_test_guide_one"
            title="In-app Hearing Test Guide I"
            url="/TakeAHearingTestWithUs.pdf"
          />
          <DownloadCard
            id="support_start_starter_kit_one"
            title="Starter Kit I"
            url="/StarterKit.pdf"
          />
        </div>
      ) : (
        <div className={styles.downloadCardWrapper}>
          <DownloadCard
            id="support_start_quich_start_guide_two"
            title="Quick Start Guide II"
            url="/OrkaTwoQuickStartGuide.pdf"
          />
          <DownloadCard
            id="support_start_user_manual_two"
            title="User Manual II"
            url="/OrkaTwoUserManual.pdf"
          />
          <DownloadCard
            id="support_start_tech_book_two"
            title="Tech Book II"
            url="/OrkaTwoTechBook.pdf"
          />
          <DownloadCard
            id="starter_kit_two"
            title="Starter Kit II"
            url="/OrkaTwoStarterKit.pdf"
          />
        </div>
      )}
    </Section>
  )
}

const SupportBody = () => {
  const dispatch = useDispatch()
  return (
    <>
      <Section minHeight="50vh" className={styles.background}>
        <Typography variant="h1" color="#FFF">
          Support Center
        </Typography>
      </Section>
      <Section
        sx={{
          py: '0 !important',
          transform: `translateY(-72.5px)`
        }}
      >
        <Box className={styles.contactWrapper}>
          <ContactCard
            id="support_email_us"
            icon={<EmailSimple40 />}
            title="Email us"
            content="support@hiorka.com"
            onClick={() => {
              window.location.href = 'mailto:support@hiorka.com'
            }}
          />
        </Box>
      </Section>
      <Box sx={{ transform: 'translateY(-72.5px)' }}>
        <Section sx={{ py: '0 !important', my: '64px' }}>
          <Typography variant="h2">How-to Video</Typography>
          <Typography variant="body2" mt={2}>
            Set-up Basics | Care & Maintenance | Advanced Function
          </Typography>
          <Button
            id="support_view_video"
            variant="secondary"
            size="large"
            className={styles.button}
            onClick={() => {
              window.location = './HowToVideo'
            }}
          >
            View How-to Video
          </Button>
        </Section>
        <Section sx={{ py: '0 !important', my: '64px' }}>
          <Typography variant="h2">Troubleshooting</Typography>
          <Typography variant="body2" mt={2}>
            Sound | Battery | Control | Bluetooth | Firmware Updates
          </Typography>
          <Button
            id="support_view_troubleshooting"
            variant="secondary"
            size="large"
            className={styles.button}
            onClick={() => {
              window.location = './TroubleShooting'
            }}
          >
            View Troubleshooting
          </Button>
        </Section>
        <GetStarted />
      </Box>
    </>
  )
}

export default function Support() {
  return (
    <>
      <NextSeo
        title="Support Center | Orka Hearing Aids"
        description="Find quick answers to your hearing aid questions, access helpful guides, and experience our unrivaled customer support."
      />
      <Header isFixed />
      <SupportBody />
      <Footer />
    </>
  )
}
